var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtmlBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 294.273,
    height: 414.529,
    viewBox: "0 0 294.273 414.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "html-black",
    transform: "translate(-10.949 -5.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M32.874,42.671H50.009V61.438H68.75V5.391H50.009V23.913H32.874V5.391H14.141V61.438H32.874Z",
    transform: "translate(23.804 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M38.044,61.438H56.777V23.989H73.261V5.391h-51.7v18.6H38.044Z",
    transform: "translate(79.137 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M46.965,33.672,59.871,53.589h.313L73.064,33.672V61.438H91.729V5.391H72.193L60.183,25.114,48.174,5.391H28.646V61.438H46.965Z",
    transform: "translate(131.973 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M82.285,42.925H55.94V5.391H37.207V61.438H82.285Z",
    transform: "translate(195.815 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M10.949,14.926,37.742,315.433l120.272,33.381L278.379,315.45,305.223,14.926ZM247.1,113.2H106.052l3.366,37.745H243.746L233.64,264.13l-75.558,20.932-.051.017L82.524,264.13l-5.269-59.2h36.992l2.74,30.709,41.052,11.1.051-.017h0l41.094-11.1,4.279-47.8H75.724L65.77,76.36H250.385Z",
    transform: "translate(0 71.106)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlBlack);
export default __webpack_public_path__ + "static/media/html-black.94b3324bb8b12b160f2877ef6c604241.svg";
export { ForwardRef as ReactComponent };